import { render, staticRenderFns } from "./SickLeaveCreationModal.vue?vue&type=template&id=d56bf6d0&scoped=true&"
import script from "./SickLeaveCreationModal.vue?vue&type=script&lang=ts&"
export * from "./SickLeaveCreationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56bf6d0",
  null
  
)

export default component.exports